<template>
  <v-app id="app">
    <Meta />
    <!--
    <div class="float_banner2">

  <div id='scrollmenu' name="scrolltop">
    
  <div class="float_banner_tt">부고보내기</div>
  <div align="center" v-for="(obituary,index) in getMainObituaryList" :key="index" class="float_banner_item" >
    <a  @click="requestMainObituarySend(obituary)" >
      <p>{{obituary.obituaryName}}</p>
      <p>부고보내기</p>
    </a>
  </div>

  </div>
    </div>
-->

    <div id="deemed" :class="getDeemState ? 'active' : ''" />
    <div class="loader" :class="getloadingState ? 'active' : ''">
      <div class="loader-item">
        <div class="loader-wheel"></div>
        <div class="loader-text"></div>
      </div>
    </div>

    <tablet-header v-if="tabletNav" />
    <admin-header v-if="showNav" />
    <!-- <v-navigation-drawer
      :mini-variant.sync="mini"
      permanent
      app
      v-bind="$attrs"
    >
    </v-navigation-drawer> -->

    <!-- Provides the application the proper gutter -->

    <template>
      <router-view
        v-if="getRequestAllFlag"
        :key="$route.fullPath"
      ></router-view>
    </template>
  </v-app>
</template>

<script>
import "@/assets/js/jquery-1.9.1.min.js";
import "@/assets/js/jQuery.print.js";
import "@/assets/js/jquery-ui.js";

import "@/assets/js/excanvas.js";
import { mapGetters } from "vuex";
import myMixin from "@/mixin/mixin";
import AdminHeader from "@/components/common/AdminHeader.vue";
import Meta from "@/components/common/Meta.vue";
import TabletHeader from "./components/common/TabletHeader.vue";

export default {
  name: "App",
  mixins: [myMixin],
  components: { AdminHeader, Meta, TabletHeader },

  created() {
    var filter = "win16|win32|win64|mac|macintel";
    // if (navigator.platform && true) {
    //   if (filter.indexOf(navigator.platform.toLowerCase()) < 0) {
    //     // mobile

    //     if (location.host !== "m.jrbaksa.com") {
    //       $(location).attr("href", "https://m.jrbaksa.com");
    //       return;
    //     }
    //   } else {
    //     // pc
    //     if (location.href.indexOf("shop") === -1) {
    //       if (location.host !== "user.jrbaksa.com") {
    //         $(location).attr("href", "https://user.jrbaksa.com");
    //         return;
    //       }
    //     }
    //   }
    // }
    this.$nextTick(function() {
      this.$store.dispatch("REQUEST_ALL_CODE_LIST");
    });
  },
  mounted() {
    // localStorage.removeItem("access_token");
    let access_token = localStorage.getItem("access_token");
    let access_type = localStorage.getItem("access_type");
    if (
      location.hash.indexOf("#/director") !== -1 &&
      access_token &&
      access_type === "director"
    ) {
      this.$store.dispatch("DIRECTOR_DETAIL");
    }
    if (
      location.hash.indexOf("#/corp") !== -1 &&
      access_token &&
      access_type === "corp"
    ) {
      this.$store.dispatch("CORP_DETAIL");
    }
    if (
      location.hash.indexOf("#/funeral") !== -1 &&
      access_token &&
      access_type === "funeral"
    ) {
      this.$store.dispatch("FUNERAL_DETAIL");
    }
    // if(location.host !== "m.jrbaksa.com")
    // }

    //최신버전 바로가기 생성 불가
    /*
    var shortcutck = document.cookie.indexOf('shortcut')
    if ( shortcutck == -1 ) {
    document.write("<object id='ShortCut' style='position:absolute'");
    document.write("codebase='http://inlive.co.kr/js/ShortCut.cab#version=1,0,0,13' width=0");
    document.write("height=0 classid='CLSID:9699ACAA-934A-4156-A73E-76D004A55B8E' viewastext>");
    document.write("</object>");
    }
        */
    // var WshShell = new ActiveXObject("WScript.Shell");
    // var strDesktop = WshShell.SpecialFolders("Desktop");
    // var oUrlLink = WshShell.CreateShortcut(strDesktop + "\\okjsp.url");
    // oUrlLink.TargetPath = "http://www.okjsp.pe.kr";
    // oUrlLink.Save();

    // this.MakeShortCut("전나라", "http://www.aaa.com/", "http://www.aaa.com/logo/logo_batang.ico",0)
    //this.bookmarksite('장례박사',"http://www.jangryebaksa.com/user");

    /* var shortcutck = document.cookie.indexOf('shortcut')
      if ( shortcutck == -1 ) {
      document.write("<object id='ShortCut' style='position:absolute'");
      document.write("codebase='http://inlive.co.kr/js/ShortCut.cab#version=1,0,0,13' width=0");
      document.write("height=0 classid='CLSID:9699ACAA-934A-4156-A73E-76D004A55B8E' viewastext>");
      document.write("</object>");
    }
*/
  },
  updated() {},
  data() {
    return {
      mini: false,
      drawer: true
    };
  },
  computed: {
    ...mapGetters([
      "getloadingState",
      "getDeemState",
      "getRequestAllFlag",
      "getMainObituaryList"
    ]),

    tabletNav() {
      const noNavList = ["/tablet1", "/tablet2", "/tablet3"];

      if (noNavList.findIndex(v => v === this.$route.path + "") !== -1) {
        return true;
      }

      return false;
    },
    showNav() {
      const noNavList = [
        "/login",
        "/corp/loginDo",
        "/tablet1",
        "/tablet2",
        "/tablet3",
        "/director/loginDo",
        "/funeral/loginDo",
        "/joinFuneral",
        "/joinSolo",
        "/searchId",
        "/searchPw",
        "/passwordSetting",
        "/",
        "/sub/faq",
        "/sub/notice",
        "/sub/noticeView",
        "/sub/keepsake",
        "/secure",
        "/secure2",
        "/cal/wreath",
        "/cal/wreath-detail",
        "/tmp",
      ];

      if (noNavList.findIndex(v => v === this.$route.path + "") !== -1) {
        return false;
      }

      return true;
    }
  },
  methods: {
    requestMainObituarySend(obituary) {
      if (confirm(obituary.obituaryName + "님의 부고장을 전송하시겠습니까?")) {
        const parameter = {
          id: obituary.id
        };
        this.$store.dispatch("REQUEST_OBITUARY_SEND", parameter);
      }
    }
  }
};
</script>

<style>
@import "./assets/css/style.css";

@import "https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100;300;400;500&display=swap";

#app {
  position: relative;
  background: #f8f6f5;
  margin: 0px auto;
}
</style>
